const CHUNK_RELOAD_KEY = 'eco3dcor.chunk-load-reload-attempted';
const CHUNK_REFRESH_QUERY_KEY = '__fresh_assets';

const isChunkLoadFailure = (reason: unknown) => {
  const message =
    reason instanceof Error
      ? reason.message
      : typeof reason === 'string'
        ? reason
        : reason && typeof reason === 'object' && 'message' in reason
          ? String((reason as { message?: unknown }).message ?? '')
          : '';

  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('Expected a JavaScript-or-Wasm module script') ||
    message.includes('Loading chunk') ||
    message.includes('ChunkLoadError')
  );
};

const reloadOnceForFreshAssets = () => {
  if (typeof window === 'undefined') return;
  try {
    if (window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === 'true') return;
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
  } catch {
    return;
  }
  const url = new URL(window.location.href);
  url.searchParams.set(CHUNK_REFRESH_QUERY_KEY, String(Date.now()));
  window.location.replace(url.toString());
};

export function registerChunkLoadRecovery() {
  if (typeof window === 'undefined') return;

  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.has(CHUNK_REFRESH_QUERY_KEY)) {
    currentUrl.searchParams.delete(CHUNK_REFRESH_QUERY_KEY);
    window.history.replaceState({}, document.title, currentUrl.toString());
  }

  window.addEventListener('unhandledrejection', (event) => {
    if (!isChunkLoadFailure(event.reason)) return;
    event.preventDefault();
    reloadOnceForFreshAssets();
  });

  window.addEventListener('error', (event) => {
    if (!isChunkLoadFailure(event.error ?? event.message)) return;
    event.preventDefault();
    reloadOnceForFreshAssets();
  });

  window.setTimeout(() => {
    try {
      window.sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    } catch {
      // Ignore storage failures; the recovery path is best-effort.
    }
  }, 5000);
}
